module.exports = __webpack_public_path__ + "img/closed-mailbox-with-raised-flag.ec025cd7.svg";